import { AutomatedTriggerType, CampaignMessageType, ScheduledCampaignStatus } from '../../graphQL/generated/enums'
import I18n from '../../shared-lib/i18n/i18n'

export const recipientText = (data: SmsCampaign | EmailCampaign, i18n: I18n) => {
  const { applyToAllClients, customRecipientIds, recipientClientGroups } = data
  const { pluralise } = i18n

  let recpientsText = '0 clients'

  if (applyToAllClients) {
    recpientsText = 'All clients'
  }

  if (!!customRecipientIds.length) {
    const clientsNumber = customRecipientIds.length
    recpientsText = `${clientsNumber} ${pluralise('client', clientsNumber)}`
  }

  if (!!recipientClientGroups.length) {
    const groupsNumber = recipientClientGroups.length
    recpientsText = `${recipientClientGroups.length} client ${pluralise('group', groupsNumber)}`
  }

  return recpientsText
}

export const sentCountText = (data: SmsCampaign | EmailCampaign, i18n: I18n) => {
  const { s } = i18n
  const { status, sentCount } = data

  if (status === 'scheduled') {
    return s('Sending to $0', recipientText(data, i18n))
  }

  const messageTypeString = data.messageType === 'sms' ? 'messages' : 'emails'
  return s('$0 $1 sent', sentCount, messageTypeString)
}

export const automatedCampaignDefaults: AutomatedCampaign = {
  campaignId: '',
  triggerType: AutomatedTriggerType.FirstBooking,
  daysOffset: 0,
  active: false,
  sendAtHour: 12,
  messageType: CampaignMessageType.Email,
  sendLog: [],
}

export const scheduledCampaignDefaults: ScheduledCampaign = {
  campaignId: '',
  messageType: CampaignMessageType.Email,
  externalClientIds: [],
  scheduledFor: new Date(),
  status: ScheduledCampaignStatus.Draft,
}

export const triggerTypesForFilter = {
  loyalty: [
    AutomatedTriggerType.LoyaltyCompleted,
    AutomatedTriggerType.LoyaltyAlmost,
    AutomatedTriggerType.LoyaltyHalf,
  ],
  clientReferral: [
    AutomatedTriggerType.ClientReferralCompleted,
    AutomatedTriggerType.ClientReferralAlmost,
    AutomatedTriggerType.ClientReferralHalf,
  ],
  default: null,
}

/*
 * Format is either:
 * https://storage.googleapis.com/secretspa-app-images-nonprod/saas/63039fd9f9123903ad1917e9-crm-1723553369875.jpg
 * https://ik.imagekit.io/booksolo/images-nonprod/saas/639b24c0f8661d5e137c4f6b-crm-1749124231904.jpg
 */
export const fileNameFromUrl = (url: string | undefined | null) => {
  if (!!url && url.includes('saas/')) {
    return url.split('saas/')[1].split('?')[0]
  }
  return ''
}